var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// chartjs/line-chart.ts
import { CategoryScale, Legend, LinearScale, LineController, LineElement, PointElement } from "chart.js";
import BaseChart from "./chart-js.js";
import { customElement } from "lit/decorators.js";
var LineChart = class extends BaseChart {
  constructor() {
    super();
    this.type = "line";
    LineChart.Chart.register(LineController, LineElement, CategoryScale, LinearScale, PointElement, Legend);
  }
};
LineChart = __decorateClass([
  customElement("line-chart")
], LineChart);
export {
  LineChart
};
